import { useCopyToClipboard } from 'react-use';

import { Check, Copy } from '@air/next-icons';

export type CustomFieldFormAPIInformationCopyValueProps = {
  id: string;
};

export const CustomFieldFormAPIInformationCopyValue = ({ id }: CustomFieldFormAPIInformationCopyValueProps) => {
  const [state, copyToClipboard] = useCopyToClipboard();

  return (
    <div className="group/custom-field-api-value inline-flex gap-1">
      <button className="select-all text-12 text-grey-9" onClick={() => copyToClipboard(id)} type="button">
        {id}
      </button>

      {state.value ? (
        <Check className="size-4 text-blue-9" />
      ) : (
        <Copy className="hidden size-4 text-grey-9 group-hover/custom-field-api-value:block" />
      )}
    </div>
  );
};
